import { useMemo } from "react"
import { useQuery } from "@apollo/client"
import { COACH_TOOLS_API } from "../../../apolloClient"
import { adaptLifelongLearningMe } from "./adapters"

// Membership reads are live Oracle reads, so they skip the cache and refetch
// after Education mutations.
export const useLifelongLearningQuery = (query, options = {}) => {
  const result = useQuery(query, {
    fetchPolicy: "network-only",
    context: { api: COACH_TOOLS_API },
    ...options,
  })
  const { data } = result
  const adaptedData = useMemo(
    () => (data?.me ? { ...data, me: adaptLifelongLearningMe(data.me) } : data),
    [data],
  )

  return { ...result, data: adaptedData, me: adaptedData?.me }
}
